module.exports = __webpack_public_path__ + "static/media/Episode_Hero_Tablet.48670a5b.png";